import { combineReducers } from 'redux';
import authReducer from './auth';
import partsReducer from './parts';
import tasksReducer from './tasks';
import ratesReducer from './rates';
import clientsReducer from './clients';
import usersReducer from './users';
import screenReducer from './screen';
import rolesReducer from './roles';
import brandsReducer from './brands';
import modelsReducer from './models';
import vehiclesReducer from './vehicles';
import vehicleReducer from './vehicle';
import visitsReducer from './visits';
import visitReducer from './visit';
import visitTasksReducer from './visitTasks';
import visitPartsReducer from './visitParts';
import visitImagesReducer from './visitiImages';
import specificationsReducer from './specifications';
import analyticsReducer from './analytics';
import eventsReducer from './events';
import notesReducer from './notes';

const rootReducer = combineReducers({
  auth: authReducer,
  screen: screenReducer,
  roles: rolesReducer,
  vehicles: vehiclesReducer,
  vehicle: vehicleReducer,
  visits: visitsReducer,
  visit: visitReducer,
  visitTasks: visitTasksReducer,
  visitParts: visitPartsReducer,
  visitImages: visitImagesReducer,
  specifications: specificationsReducer,
  tasks: tasksReducer,
  parts: partsReducer,
  clients: clientsReducer,
  rates: ratesReducer,
  brands: brandsReducer,
  models: modelsReducer,
  users: usersReducer,
  analytics: analyticsReducer,
  events: eventsReducer,
  notes: notesReducer,
});

export default rootReducer;
